import React, { useState, useEffect } from 'react';
import {
  MdDashboard,
  MdPerson,
  MdCalendarToday,
  MdBookOnline,
  MdMenuBook,
  MdRateReview,
} from 'react-icons/md';
import { FaBars, FaTimes } from 'react-icons/fa';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs, doc, getDoc, deleteDoc } from 'firebase/firestore';
import { InlineWidget } from "react-calendly";
import { db } from '../firebase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Dashboard = () => {
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('Home');
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fullName, setFullName] = useState("Friend");
  const [user, setUser] = useState(null);

  const tabs = [
    { label: 'Home', icon: <MdDashboard /> },
    { label: 'Your Profile', icon: <MdPerson /> },
    { label: 'Coaching Sessions', icon: <MdCalendarToday /> },
    { label: 'Book Session', icon: <MdBookOnline /> },
    { label: 'Resources', icon: <MdMenuBook /> },
    { label: 'Feedback', icon: <MdRateReview /> },
  ];

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        try {
          const q = query(collection(db, 'sessions'), where('userId', '==', user.uid));
          const snapshot = await getDocs(q);
          const today = new Date().toISOString().split('T')[0];
          const upcoming = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((s) => s.date >= today)
            .sort((a, b) => a.date.localeCompare(b.date));
          setSessions(upcoming);

          const userDocRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userDocRef);
          if (userSnap.exists()) {
            const data = userSnap.data();
            setFullName(data.fullName || user.displayName || "Friend");
          } else {
            setFullName(user.displayName || "Friend");
          }

        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  const handleCancel = async (sessionId) => {
    if (!window.confirm("Are you sure you want to cancel this session?")) return;
    try {
      await deleteDoc(doc(db, "sessions", sessionId));
      setSessions((prev) => prev.filter((s) => s.id !== sessionId));
    } catch (error) {
      console.error("Failed to cancel session:", error);
      alert("There was an issue cancelling your session.");
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Your Profile':
        return (
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-10">
            <aside className="w-full md:w-1/4 space-y-8">
              <div className="text-center">
                {user?.photoURL && (
                  <img src={user.photoURL} alt="Profile" className="w-32 h-32 rounded-full mx-auto object-cover border" />
                )}
                <h2 className="text-xl font-bold mt-4">{fullName}</h2>
              </div>
             
            </aside>
            <main className="flex-1 space-y-10">
              <div className="border rounded-lg p-6 bg-gray-50">
                <p className="text-sm text-gray-800 font-medium mb-2">✨ Hey, Welcome {fullName}!</p>
                <p className="text-gray-700 text-sm mb-4">
                  Hello and welcome! I'm thrilled to have you here and excited to be part of your journey toward your objectives.
                  This portal is designed to be your go-to resource throughout our coaching experience.
                </p>
                <p className="text-sm text-pink-600 underline mb-2">
                  <a href="#">Here’s what you can expect:</a>
                </p>
                <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1">
                  <li><span className="font-semibold">Personalized Coaching:</span> Access notes, resources, & action plans.</li>
                  <li><span className="font-semibold">Progress Tracking:</span> Stay motivated by keeping an eye on your milestones and accomplishments.</li>
                  <li><span className="font-semibold">Communication:</span> Reach out through our messaging system.</li>
                </ul>
              </div>
              <section>
                <h2 className="text-sm text-gray-600 font-semibold mb-4">📁 Upcoming and past calls</h2>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {sessions.length === 0 ? (
                    <p className="text-sm text-gray-400">No booked sessions yet.</p>
                  ) : (
                    sessions.map((session) => (
                      <div key={session.id} className="aspect-square border border-dashed border-gray-300 bg-gray-50 flex flex-col items-center justify-center text-sm font-semibold text-gray-700 rounded-md text-center p-2">
                        <p>{session.type}</p>
                        <p className="text-xs text-gray-500">{session.date} @ {session.time}</p>
                      </div>
                    ))
                  )}
                </div>
              </section>
            </main>
          </div>
        );
      case 'Book Session':
return (
  <div className="p-4 space-y-4">
    <h2 className="text-lg font-semibold">Book a New Session</h2>
    <p className="text-gray-700">Click the button below to schedule your session via Calendly.</p>

    <a
      href="https://calendly.com/woaomwebdesign/30min"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block px-6 py-3 bg-[#1A3C34] text-white font-medium rounded-lg shadow hover:bg-[#254c41] transition"
    >
      📅 Book a 30-Min Session
    </a>
  </div>
);

      case 'Coaching Sessions':
        return  <section>
                <h2 className="text-sm text-gray-600 font-semibold mb-4">📁 Upcoming and past calls</h2>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {sessions.length === 0 ? (
                    <p className="text-sm text-gray-400">No booked sessions yet.</p>
                  ) : (
                    sessions.map((session) => (
                      <div key={session.id} className="aspect-square border border-dashed border-gray-300 bg-gray-50 flex flex-col items-center justify-center text-sm font-semibold text-gray-700 rounded-md text-center p-2">
                        <p>{session.type}</p>
                        <p className="text-xs text-gray-500">{session.date} @ {session.time}</p>
                      </div>
                    ))
                  )}
                </div>
              </section>;




      case 'Resources':
        return <section className="mb-12">
  {/* Resource Links */}
  <div className="mb-8">
    <h2 className="text-lg font-semibold mb-4">📄 Resources</h2>
    <ul className="space-y-2 text-sm text-gray-800">
      <li>
        <a
          href="https://example.com/your-pdf-file.pdf"
          target="_blank"
          rel="noreferrer"
          className="underline text-blue-700 hover:text-blue-900"
        >
          📘 Download: Starter Guide PDF
        </a>
      </li>
      <li>
        <a
          href="https://www.notion.so/your-notion-page"
          target="_blank"
          rel="noreferrer"
          className="underline text-blue-700 hover:text-blue-900"
        >
          🗂 View: Notion Workspace
        </a>
      </li>
    </ul>
  </div>

  {/* Video Lessons */}
  <h2 className="text-lg font-semibold mb-6">🎥 Video Lessons</h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    <a
      href="https://your-video-link.com"
      target="_blank"
      rel="noreferrer"
      className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition"
    >
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">1</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Lesson: Welcome</p>
    </a>

    <a
      href="https://your-video-link.com"
      target="_blank"
      rel="noreferrer"
      className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition"
    >
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">2</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Lesson: Vision & Goals</p>
    </a>

    <a
      href="https://your-video-link.com"
      target="_blank"
      rel="noreferrer"
      className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition"
    >
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">3</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Lesson: Next Steps</p>
    </a>
  </div>
</section>



;
      case 'Feedback':
        return <p className="text-gray-700">Share your thoughts and feedback. (Coming soon)</p>;
      case 'Home':
      default:
        return (
          <div className="p-4">
            <section className="mb-10">
  <h2 className="text-xs text-gray-500 uppercase tracking-wide mb-3">📋 Board</h2>
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
    <BoardCard icon="💬" label="Who am I?" />
    <BoardCard icon="🍀" label="My personal vision" />
    <BoardCard icon="📞" label="Business Info" />
    <BoardCard icon="💡" label="My mission" />
  </div>
</section>

<section className="mb-12">
  <h1 className="text-xl font-semibold mb-2">Hello {fullName}! Welcome to your coaching portal</h1>
  <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-md mb-4">
    <p className="font-medium text-yellow-800 mb-1">⭐ Greeting</p>
    <p className="text-gray-700 text-sm">
      Welcome to your personal Coaching Portal! I'm excited to embark on this journey with you,
      where we'll work together to achieve your goals, overcome challenges, and unlock your full potential.
    </p>
  </div>
  <details className="bg-gray-50 border border-gray-200 p-4 rounded-md">
    <summary className="font-medium cursor-pointer">📖 Coaching Philosophy</summary>
    <p className="mt-2 text-sm text-gray-700">
      My coaching philosophy is rooted in empowerment and clarity, guiding you toward purpose-aligned action...
    </p>
  </details>
</section>

<section className="mb-12">
  <h2 className="text-lg font-semibold mb-2">📅 Upcoming Sessions</h2>
  {loading ? (
    <p className="text-gray-500">Loading...</p>
  ) : sessions.length === 0 ? (
    <p className="text-gray-600">You have no upcoming sessions.</p>
  ) : (
    <ul className="space-y-4">
      {sessions.map((session) => (
        <li key={session.id} className="bg-white border p-4 rounded shadow-sm">
          <p><strong>{session.type || "Session"}:</strong> {session.date} at {session.time}</p>
          {session.notes && <p className="text-sm text-gray-500">📝 {session.notes}</p>}
          <div className="mt-2 flex gap-4 text-sm">
            <a href={`/booksession?reschedule=${session.id}`} className="text-blue-600 hover:underline">Reschedule</a>
            <button onClick={() => handleCancel(session.id)} className="text-red-600 hover:underline">Cancel</button>
          </div>
        </li>
      ))}
    </ul>
  )}
</section>

<section className="mb-12">
  <h2 className="text-lg font-semibold mb-6">📚 Resources</h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    <a href="https://notion.so" target="_blank" rel="noreferrer" className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition">
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">1</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Client Workbook</p>
    </a>
    <a href="https://drive.google.com" target="_blank" rel="noreferrer" className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition">
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">2</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Video Lessons</p>
    </a>
    <a href="/booksession" className="bg-[#FAF9F7] text-center rounded-lg shadow-sm py-16 relative hover:shadow-md transition">
      <div className="text-6xl text-[#E6E2D6] font-bold absolute top-8 left-0 right-0 mx-auto">3</div>
      <p className="mt-24 text-sm font-medium text-gray-800 underline">Book Session</p>
    </a>
  </div>
</section>

            {/* You can expand this section with more home page content */}
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex flex-1 py-14">
        <aside className="w-64 border-r border-gray-200 p-6 hidden md:block">
          <ul className="space-y-4">
            {tabs.map(({ label, icon }) => (
              <li key={label}>
                <button
                  onClick={() => setActiveTab(label)}
                  className={`flex items-center gap-3 px-2 py-2 text-md rounded transition-colors w-full text-left ${activeTab === label ? 'bg-[#dbe5dc]' : 'hover:bg-[#f1f4ec]'}`}
                >
                  <span className="text-xl">{icon}</span>
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </aside>
        <main className="flex-1 p-6 md:p-12 bg-white">
          {renderTabContent()}
        </main>
      </div>
      <Footer />
    </div>
  );
};

function BoardCard({ icon, label }) {
  return (
    <div className="flex flex-col items-center justify-center border border-gray-200 rounded-md p-4 bg-white hover:shadow-sm transition">
      <div className="text-3xl mb-2">{icon}</div>
      <p className="text-sm font-medium text-gray-800 text-center">{label}</p>
    </div>
  );
}

export default Dashboard;
